<template>
  <div class="project">
    <i-myHead></i-myHead>
    <div class="Management-projects-i-layout layout">
      <i-layout :default-collapsed="false" class="layout_wrap">
        <i-sider class="layout-sider" hide-trigger collapsible :collapsed-width="71" v-model="isCollapsed" ref="side1">
          <i-menu
            class="layout-sider-menu"
            theme="light"
            width="auto"
            :active-name="selected"
            :open-names="['statistics', 'meeting', 'team', 'content']"
          >
            <i-submenu name="statistics" :class="!collpsed ? 'collapsed-menu' : ''">
              <template slot="title">
                <i-poptip class="mypiptip" v-show="!collpsed" trigger="hover" :transfer="true" placement="right-start">
                  <i-icon class="iconfont icon-shengtaiquan" name="icon" size="24"></i-icon>
                  <div slot="content">
                    <i-menuItem
                      class="sidebar-item"
                      v-show="!collpsed"
                      name="project/IndexMark"
                      to="/project/IndexMark"
                    >
                      指数管理
                    </i-menuItem>
                    <i-menuItem
                      class="sidebar-item"
                      v-show="!collpsed"
                      name="project/IndexSystem"
                      to="/project/IndexSystem"
                    >
                      指标体系
                    </i-menuItem>
                  </div>
                </i-poptip>
                <div v-show="collpsed" style="margin-left: -15px;">
                  <i class=" iconfont icon-shengtaiquan iconfont_1"></i>
                  <span>
                    生态指数
                  </span>
                </div>
              </template>
              <i-menuItem
                name="project/IndexMark"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/IndexMark"
              >
                指数管理
              </i-menuItem>
              <i-menuItem
                name="project/IndexSystem"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/IndexSystem"
              >
                指标体系
              </i-menuItem>
            </i-submenu>
            <i-submenu name="meeting" :class="!collpsed ? 'collapsed-menu' : ''">
              <template slot="title">
                <i-poptip class="mypiptip" v-show="!collpsed" trigger="hover" :transfer="true" placement="right-start">
                  <i-icon class="iconfont icon-peizhi" name="icon" size="24"></i-icon>
                  <div slot="content">
                    <i-menuItem
                      class="sidebar-item"
                      v-show="!collpsed"
                      name="/project/meetingDesc"
                      to="/project/meetingDesc"
                    >
                      大会简介
                    </i-menuItem>
                    <i-menuItem
                      class="sidebar-item"
                      v-show="!collpsed"
                      name="/project/platformDesc"
                      to="/project/platformDesc"
                    >
                      协同创新平台简介
                    </i-menuItem>
                    <i-menuItem
                      class="sidebar-item"
                      v-show="!collpsed"
                      name="/project/reportDown"
                      to="/project/reportDown"
                    >
                      报告下载
                    </i-menuItem>
                    <i-menuItem class="sidebar-item" v-show="!collpsed" name="/project/partner" to="/project/partner">
                      合作方
                    </i-menuItem>
                    <i-menuItem class="sidebar-item" v-show="!collpsed" name="/project/thanks" to="/project/thanks">
                      特别鸣谢
                    </i-menuItem>
                    <i-menuItem
                      class="sidebar-item"
                      v-show="!collpsed"
                      name="/project/mediaReport"
                      to="/project/mediaReport"
                    >
                      媒体报道
                    </i-menuItem>
                  </div>
                </i-poptip>
                <div v-show="collpsed" style="margin-left: -15px;">
                  <i class="iconfont icon-taiwangdahui-shouyedianjitai iconfont_1"></i>
                  <span>
                    数字生态大会
                  </span>
                </div>
              </template>
              <i-menuItem
                name="project/meetingDesc"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/meetingDesc"
              >
                大会简介
              </i-menuItem>
              <i-menuItem
                name="project/platformDesc"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/platformDesc"
              >
                协同创新平台简介
              </i-menuItem>
              <i-menuItem
                name="project/reportDown"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/reportDown"
              >
                报告下载
              </i-menuItem>
              <i-menuItem
                name="project/partner"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/partner"
              >
                合作方
              </i-menuItem>
              <i-menuItem
                name="project/thanks"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/thanks"
              >
                特别鸣谢
              </i-menuItem>
              <i-menuItem
                name="project/mediaReport"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/mediaReport"
              >
                媒体报道
              </i-menuItem>
            </i-submenu>
            <i-menuItem name="project/summary" class="sidebar-item sidebar-title" to="/project/summary">
              <i v-show="!collpsed" class="iconfont icon-fangfa" style="fontSize:24px"></i>
              <div v-show="collpsed">
                <i class="iconfont icon-fangfa iconfont_1" style="fontSize:20px"></i>
                <span>方法概述</span>
              </div>
            </i-menuItem>
            <i-menuItem name="/project/laboratory" class="sidebar-item sidebar-title" to="/project/laboratory">
              <i v-show="!collpsed" class="iconfont icon-CPhezuo" style="fontSize:24px"></i>
              <div v-show="collpsed">
                <i class="iconfont icon-CPhezuo iconfont_1"></i>
                <span>实验室介绍</span>
              </div>
            </i-menuItem>
            <i-submenu name="team" :class="!collpsed ? 'collapsed-menu' : ''">
              <template slot="title">
                <i-poptip class="mypiptip" v-show="!collpsed" trigger="hover" :transfer="true" placement="right-start">
                  <i-icon class="iconfont icon-peizhi" name="icon" size="24"></i-icon>
                  <div slot="content">
                    <i-menuItem class="sidebar-item" v-show="!collpsed" name="/project/expert" to="/project/expert">
                      专家团队
                    </i-menuItem>
                    <i-menuItem class="sidebar-item" v-show="!collpsed" name="/project/project" to="/project/project">
                      项目团队
                    </i-menuItem>
                  </div>
                </i-poptip>
                <div v-show="collpsed" style="margin-left: -15px;">
                  <i class="iconfont icon-peizhi iconfont_1"></i>
                  <span>
                    专家团队
                  </span>
                </div>
              </template>
              <i-menuItem
                name="project/expert"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/expert"
              >
                专家团队
              </i-menuItem>
              <i-menuItem
                name="project/project"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/project"
              >
                项目团队
              </i-menuItem>
            </i-submenu>
            <i-menuItem name="project/news" class="sidebar-item sidebar-title" to="/project/news">
              <i v-show="!collpsed" class="iconfont icon-xinwen " style="fontSize:24px"></i>
              <div v-show="collpsed">
                <i class="iconfont icon-xinwen iconfont_1"></i>
                <span>新闻资讯</span>
              </div>
            </i-menuItem>
            <i-menuItem name="project/retrieval" class="sidebar-item sidebar-title" to="/project/retrieval">
              <i v-show="!collpsed" class="iconfont icon-fangfa" style="fontSize:24px"></i>
              <div v-show="collpsed">
                <i class="iconfont icon-fangfa iconfont_1" style="fontSize:20px"></i>
                <span>专家检索</span>
              </div>
            </i-menuItem>
            <i-submenu
              name="content"
              :class="!collpsed ? 'collapsed-menu' : ''"
              v-if="isAdmin"
            >
              <template slot="title">
                <i-poptip class="mypiptip" v-show="!collpsed" trigger="hover" :transfer="true" placement="right-start">
                  <i-icon class="iconfont icon-peizhi" name="icon" size="24"></i-icon>
                  <div slot="content">
                    <i-menuItem class="sidebar-item" v-show="!collpsed" name="/project/Channel" to="/project/Channel">
                      频道
                    </i-menuItem>
                    <i-menuItem class="sidebar-item" v-show="!collpsed" name="/project/Template" to="/project/Template">
                      模板
                    </i-menuItem>
                    <i-menuItem
                      class="sidebar-item"
                      v-show="!collpsed"
                      name="/project/Attribute"
                      to="/project/Attribute"
                    >
                      属性
                    </i-menuItem>
                  </div>
                </i-poptip>
                <div v-show="collpsed" style="margin-left: -15px;">
                  <i class="iconfont icon-peizhi iconfont_1"></i>
                  <span>
                    内容系统配置
                  </span>
                </div>
              </template>
              <i-menuItem
                name="project/Channel"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/Channel"
              >
                频道
              </i-menuItem>
              <i-menuItem
                name="project/Template"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/Template"
              >
                模板
              </i-menuItem>
              <i-menuItem
                name="project/Attribute"
                class="sidebar-item"
                style="fontSize:13px;margin-left: -20px;"
                v-show="collpsed"
                to="/project/Attribute"
              >
                属性
              </i-menuItem>
            </i-submenu>
          </i-menu>
        </i-sider>
        <i-layout>
          <i-content class="layout-content" :class="{ collpsed: !collpsed }">
            <router-view></router-view>
          </i-content>
        </i-layout>
      </i-layout>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
import MyHead from "./MyHead"
import {baseConfigMixin} from "./Content/mixin";
export default {
  data() {
    return {
      isCollapsed: false,
      selected: "project/article",
    }
  },
  mixins: [baseConfigMixin],
  components: {
    "i-myHead": MyHead,
  },
  computed: {
    ...mapState(["collpsed"]),
  },
  watch: {
    collpsed: function() {
      this.collapsedSider()
    },
    $route: function(newValue) {
      const route = newValue.path.substring(1)
      this.selected = route
    },
  },
  methods: {
    collapsedSider() {
      this.$refs.side1.toggleCollapse()
    },
  },
  mounted() {
    const route = this.$route.path.substr(1)
    this.selected = route
  },
}
</script>

<style scoped>
.Management-projects-i-layout {
  height: 100%;
}
.layout-sider {
  height: calc(100vh - 60px);
  background: #fff;
  width: 190px !important;
  min-width: 0px !important;
  flex: 0 0 190px !important;
  font-weight: bold;
  position: fixed;
  top: 60px;
  left: 0;
}
.sidebar-item {
  color: #212990;
}
.sidebar-item.ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected a,
.sidebar-item.ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected i,
.sidebar-item span {
  color: white;
}
.sidebar-item.ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
  color: white !important;
  background-color: #212990;
}

.sidebar-item.ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected a {
  color: white;
}
.ivu-poptip-body-content .sidebar-item.ivu-menu-item {
  padding-left: 5px !important;
}
.sidebar-item.ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected span {
  color: white;
}
>>> .sidebar-item.ivu-menu-item:hover {
  background-color: #057009;
  color: #fff !important;
}
>>> li.sidebar-item.ivu-menu-item:hover a,
li.sidebar-item.ivu-menu-item:hover span {
  color: #fff !important;
}
.sidebar-title:hover {
  background-color: #057009;
}
.sidebar-title:hover i,
.sidebar-title:hover span {
  color: #fff !important;
}
.ivu-menu-submenu-title span,
.ivu-menu-submenu-title i {
  color: #057009;
}
.sidebar-title {
  padding-right: 47px !important;
}
.sidebar-title span,
.sidebar-title i {
  color: #057009;
}
.ivu-menu-submenu-title span {
  margin-right: 20px;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.layout-content {
  margin-left: 190px;
  padding-top: 5px;
  height: calc(100vh - 60px);
}
.layout-content.collpsed {
  margin-left: 75px;
}
>>> .ivu-menu {
  color: #212990;
}
>>> .ivu-menu-vertical .ivu-menu-submenu-title-icon {
  right: 20px;
}
.collapsed-menu >>> .ivu-menu-submenu-title-icon {
  display: none;
}
.iconfont_1 {
  position: absolute;
  left: 15px;
  line-height: 20px;
  font-size: 18px;
}
/*左侧导航栏滚动条*/
>>> .ivu-layout-sider-children {
  overflow-y: auto;
}
.layout-sider >>> ::-webkit-scrollbar {
  width: 0;
  height: 0.5rem;
  max-height: 0.5rem;
}
.layout-sider >>> ::-webkit-scrollbar-track {
  -webkit-box-shadow: rgba(0, 0, 0, 0.3);
  border-radius: 0.625rem;
}
.layout-sider >>> ::-webkit-scrollbar-thumb {
  border-radius: 0.625rem;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: rgba(0, 0, 0, 0.5);
}
.layout-sider >>> ::-webkit-scrollbar-thumb:window-inactive {
  background: transparent;
}
</style>
